(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rh-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rh-menu-header')) {
    customElements.define(
      'rh-menu-header',
      class extends HTMLElement {
        connectedCallback() {
          this.abortController = new AbortController();

          const options = {
            signal: this.abortController.signal
          };

          const button = this.querySelector('.rh-mobile-toggle');
          const nav = this.querySelector('.rh-nav');
          const menus = [
            ...this.querySelectorAll('.rh-dropdown')
          ];

          const closeMenus = () => {
            menus.forEach(menu => {
              menu.open = false;
            });
          };

          const closeMobile = () => {
            nav.classList.remove('is-open');
            button.setAttribute('aria-expanded', 'false');
          };

          button.addEventListener(
            'click',
            () => {
              const open = nav.classList.toggle('is-open');
              button.setAttribute('aria-expanded', String(open));

              if (!open) closeMenus();
            },
            options
          );

          menus.forEach(menu => {
            const summary = menu.querySelector('summary');

            summary.addEventListener(
              'click',
              () => {
                menus.forEach(other => {
                  if (other !== menu) other.open = false;
                });
              },
              options
            );
          });

          document.addEventListener(
            'click',
            event => {
              if (!this.contains(event.target)) {
                closeMenus();
                closeMobile();
              }
            },
            options
          );

          this.addEventListener(
            'keydown',
            event => {
              if (event.key !== 'Escape') return;

              const activeMenu = menus.find(
                menu =>
                  menu.open &&
                  menu.contains(document.activeElement)
              );

              closeMenus();

              if (activeMenu) {
                activeMenu.querySelector('summary').focus();
              } else {
                closeMobile();
                button.focus();
              }
            },
            options
          );
        }

        disconnectedCallback() {
          this.abortController?.abort();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
